var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiEditSpark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3435_4010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3832 21.246L6.66895 21.6546L7.07752 16.9403L16.8832 7.19741C17.0296 7.04774 17.2044 6.92882 17.3973 6.84763C17.5902 6.76643 17.7975 6.72461 18.0068 6.72461C18.2161 6.72461 18.4234 6.76643 18.6163 6.84763C18.8092 6.92882 18.984 7.04774 19.1304 7.19741L21.1261 9.20884C21.2732 9.35503 21.3899 9.52887 21.4696 9.72035C21.5492 9.91183 21.5903 10.1172 21.5903 10.3246C21.5903 10.5319 21.5492 10.7373 21.4696 10.9288C21.3899 11.1202 21.2732 11.2941 21.1261 11.4403L11.3832 21.246Z",
    stroke: "#2173FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82383 6.7418C1.27226 6.64594 1.27226 5.85394 1.82383 5.75808C2.80045 5.58811 3.70433 5.13116 4.42023 4.44548C5.13613 3.7598 5.63163 2.87646 5.84355 1.90808L5.87655 1.75565C5.99598 1.21194 6.77226 1.20723 6.89798 1.75251L6.93726 1.92851C7.15695 2.89258 7.65659 3.77026 8.37343 4.45131C9.09027 5.13237 9.99236 5.58644 10.9664 5.75651C11.5211 5.8508 11.5211 6.64751 10.9664 6.74494C9.99228 6.91462 9.08999 7.36833 8.37287 8.04911C7.65575 8.72989 7.15576 9.60737 6.93569 10.5714L6.89483 10.7489C6.77069 11.2927 5.99441 11.2895 5.87498 10.7442L5.84355 10.5918C5.63142 9.62299 5.13545 8.73934 4.41895 8.05362C3.70244 7.3679 2.79788 6.9112 1.82069 6.7418H1.82383Z",
    stroke: "#04245C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3435_4010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiEditSpark);
export default __webpack_public_path__ + "static/media/ai_edit_spark.ec14b47b97e226474af5e67aba26fb90.svg";
export { ForwardRef as ReactComponent };